const expire = 60 * 60 * 24 * 7
export function setStorage(key, value, ex) {
  const stringData = JSON.stringify({
    value,
    expire: ex ? ex * 1000 : expire !== null ? new Date().getTime() + expire * 1000 : null,
  })
  localStorage.setItem(key, stringData)
}
/**
 * 读取缓存
 * @param {string} key 缓存键
 * @param {*=} def 默认值
 */
export function getStorage(key, def = null) {
  const item = localStorage.getItem(key)
  if (item) {
    try {
      const data = JSON.parse(item)
      const { value, expire } = data
      // 在有效期内直接返回
      if (expire === null || expire >= Date.now()) {
        return value
      }
      this.removeItem(key)
    } catch (e) {
      return def
    }
  }
  return def
}
/**
 * 从缓存删除某项
 * @param {string} key
 */
export function removeStorage(key) {
  localStorage.removeItem(key)
}

/**
 * 清空所有缓存
 * @memberOf Cache
 */
export function clearStorage() {
  localStorage.clear()
}

